import * as mutations from './mutations.js'
import * as actions from './actions.js'
export default {
  namespaced: true,
  state () {
    return {
      form: {
        email: undefined,
        emited: 'event',
        read: 'event',
        accepted: 'event',
        refused: 'event',
        edited: 'event',
        ignored: 'event',
        language: 'event'
      }
    }
  },
  mutations,
  actions
}
